/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, key: NonNullable<unknown> }} Live_Comment_ByInputs */

const en_live_comment_by = /** @type {(inputs: Live_Comment_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} commented on ${i?.key}`)
};

const de_live_comment_by = /** @type {(inputs: Live_Comment_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hat ${i?.key} kommentiert`)
};

/**
* | output |
* | --- |
* | "{name} commented on {key}" |
*
* @param {Live_Comment_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const live_comment_by = /** @type {((inputs: Live_Comment_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Comment_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_live_comment_by(inputs)
	return en_live_comment_by(inputs)
});